import React from 'react';
import Result from 'components/ant-design-pro/Result';
import { Button, Card } from 'antd';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import qs from 'qs';

@connect()
export default class Success extends React.Component {
  constructor(props) {
    super(props);

    this.handleBackToList = this.handleBackToList.bind(this);
    this.handelGoToAdd = this.handelGoToAdd.bind(this);
    this.handelGoToQuery = this.handelGoToQuery.bind(this);
    this.renderActions = this.renderActions.bind(this);
  }

  handleBackToList() {
    this.props.dispatch(routerRedux.replace('/operation/merchant/list'));
  }

  handelGoToAdd() {
    this.props.dispatch(routerRedux.replace(`/operation/merchant/add?type=add`));
  }

  handelGoToQuery() {
    const { merchantId } = qs.parse(this.props.location.search.slice(1));
    this.props.dispatch(
      routerRedux.replace(`/operation/merchant/edit-or-query?type=query&id=${merchantId}`)
    );
  }

  renderActions() {
    return (
      <div>
        <Button onClick={this.handleBackToList} type="primary">
          返回列表
        </Button>
        <Button onClick={this.handelGoToAdd}>继续创建</Button>
        <Button onClick={this.handelGoToQuery}>查看商户</Button>
      </div>
    );
  }

  render() {
    return (
      <Card bordered={false}>
        <Result type="success" title={<div>商户创建成功 </div>} actions={this.renderActions()} />
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/Merchant/Detail/Add/Success.js